<template>
    <span>
        <slot>{{ number }}</slot>
        <span class="label label-primary" v-if="highlightNumber">Late/Spare</span>
    </span>
</template>

<script>
    export default {
        name: "race-number",

        props: ['number'],

        computed: {
            highlightNumber() {
                return this.number >= 70000;
            }
        },
    }
</script>

<style scoped>
    .label {
        margin-left: 5px;
    }
</style>
